export const modalReducer = (state, action) => {
    switch (action.type) {
        case 'INITIALIZE_MODAL_STATE':
            const loadedFields = state.fields;
            for (const key in loadedFields) {
                loadedFields[key].value = action.payload[key];
            }
            return { ...state, fields: loadedFields };
        case 'UPDATE_VALUE': {
            const updatedFields = {
                ...state.fields,
                [action.id]: { ...state.fields[action.id], value: action.value },
            };
            return { ...state, fields: updatedFields };
        }
        case 'FOCUS_STATE': {
            const updatedFields = {
                ...state.fields,
                [action.id]: {
                    ...state.fields[action.id],
                    focus: !state.fields[action.id].focus,
                },
            };
            return { ...state, fields: updatedFields };
        }
        case 'UPDATE_IS_VALID': {
            const updatedFields = {
                ...state.fields,
                [action.id]: {
                    ...state.fields[action.id],
                    message: action.message,
                    isValid: action.isValid,
                },
            };
            return { ...state, fields: updatedFields };
        }
        default:
            return state;
    }
};
